
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en",
  "es",
  "fr"
]

export const localeLoaders = {
  "it": [],
  "en": [],
  "es": [],
  "fr": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config",
  "locales": [
    {
      "code": "it",
      "site": "it",
      "language": "it-IT",
      "name": "Italiano"
    },
    {
      "code": "en",
      "site": "en",
      "language": "en-US",
      "name": "English"
    },
    {
      "code": "es",
      "site": "es",
      "language": "es-ES",
      "name": "Español"
    },
    {
      "code": "fr",
      "site": "fr",
      "language": "fr-FR",
      "name": "Français"
    }
  ],
  "defaultLocale": "it",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://www.bioenologia.com/",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "product/[slug]": {
      "it": "/[slug]",
      "en": "/[slug]",
      "es": "/[slug]",
      "fr": "/[slug]"
    },
    "copyright/index": {
      "it": "/copyright",
      "en": "/copyright",
      "es": "/derechos-de-autor",
      "fr": "/droits-dauteur"
    },
    "perche-noi/index": {
      "it": "/perche-noi",
      "en": "/why-us",
      "es": "/por-que-nosotros",
      "fr": "/pourquoi-nous"
    },
    "servizi/index": {
      "it": "/servizi",
      "en": "/services",
      "es": "/servicios",
      "fr": "/services"
    },
    "azienda/index": {
      "it": "/azienda",
      "en": "/company",
      "es": "/agencia",
      "fr": "/agence"
    },
    "news/index": {
      "it": "/news",
      "en": "/news",
      "es": "/noticias",
      "fr": "/actualites"
    },
    "news/archivio/index": {
      "it": "/news/archivio",
      "en": "/news/archive",
      "es": "/noticias/archivo",
      "fr": "/actualites/archives"
    },
    "news/[slug]/index": {
      "it": "/news/[slug]",
      "en": "/news/[slug]",
      "es": "/noticias/[slug]",
      "fr": "/actualites/[slug]"
    },
    "risorse/index": {
      "it": "/risorse",
      "en": "/resources",
      "es": "/recursos",
      "fr": "/ressources"
    },
    "contatti/[product]": {
      "it": "/contatti/[product]",
      "en": "/contacts/[product]",
      "es": "/contactos/[product]",
      "fr": "/contacts/[product]"
    },
    "contatti/index": {
      "it": "/contatti",
      "en": "/contacts",
      "es": "/contactos",
      "fr": "/contacts"
    },
    "vino/index": {
      "it": "/vino",
      "en": "/wine",
      "es": "/vino",
      "fr": "/vin"
    },
    "vino/[slug]/index": {
      "it": "/vino/[slug]",
      "en": "/wine/[slug]",
      "es": "/vino/[slug]",
      "fr": "/vin/[slug]"
    },
    "vino/[slug]/autoctoni": {
      "it": "/vino/[slug]/autoctoni",
      "en": "/wine/[slug]/indigenous",
      "es": "/vino/[slug]/autoctonos",
      "fr": "/vin/[slug]/indigenes"
    },
    "vino/[slug]/lieviti-per-vino-rosso": {
      "it": "/vino/[slug]/lieviti-per-vino-rosso",
      "en": "/wine/[slug]/yeasts-for-red-wine",
      "es": "/vino/[slug]/levaduras-para-vino-tinto",
      "fr": "/vin/[slug]/levures-pour-vin-rouge"
    },
    "vino/[slug]/lieviti-per-vino-bianco": {
      "it": "/vino/[slug]/lieviti-per-vino-bianco",
      "en": "/wine/[slug]/yeasts-for-white-wine",
      "es": "/vino/[slug]/levaduras-para-vino-blanco",
      "fr": "/vin/[slug]/levures-pour-le-vin-blanc"
    },
    "vino/[slug]/lieviti-per-vino-rosato": {
      "it": "/vino/[slug]/lieviti-per-vino-rosato",
      "en": "/wine/[slug]/yeasts-for-rose-wine",
      "es": "/vino/[slug]/levaduras-para-vino-rosado",
      "fr": "/vin/[slug]/levures-pour-vins-rose"
    },
    "vino/[slug]/lieviti-per-spumante": {
      "it": "/vino/[slug]/lieviti-per-spumante",
      "en": "/wine/[slug]/sparkling-wine-yeast",
      "es": "/vino/[slug]/levaduras-para-vino-espumoso",
      "fr": "/vin/[slug]/levures-pour-vins-mousseux"
    },
    "vino/[slug]/lieviti-per-vini-aromatici": {
      "it": "/vino/[slug]/lieviti-per-vini-aromatici",
      "en": "/wine/[slug]/yeasts-for-aromatic-wines",
      "es": "/vino/[slug]/levaduras-para-vinos-aromáticos",
      "fr": "/vin/[slug]/levures-pour-vins-aromatiques"
    },
    "vino/[slug]/lieviti-per-vini-senza-solfiti": {
      "it": "/vino/[slug]/lieviti-per-vini-senza-solfiti",
      "en": "/wine/[slug]/yeasts-for-sulfite-free-wines",
      "es": "/vino/[slug]/levaduras-para-vinos-sin-sulfitos",
      "fr": "/vin/[slug]/levures-pour-vins-sans-sulfites"
    },
    "vino/[slug]/lieviti-per-vini-dolci": {
      "it": "/vino/[slug]/lieviti-per-vini-dolci",
      "en": "/wine/[slug]/yeasts-for-sweet-wines",
      "es": "/vino/[slug]/levaduras-para-vino-dulce",
      "fr": "/vin/[slug]/levures-pour-vin-doux"
    },
    "vino/[slug]/[sottocategoria]/index": {
      "it": "/vino/[slug]/[sottocategoria]",
      "en": "/wine/[slug]/[sottocategoria]",
      "es": "/vino/[slug]/[sottocategoria]",
      "fr": "/vin/[slug]/[sottocategoria]"
    },
    "vino/[slug]/lieviti-saccharomyces": {
      "it": "/vino/[slug]/lieviti-saccharomyces",
      "en": "/wine/[slug]/saccharomyces-yeasts",
      "es": "/vino/[slug]/levaduras-saccharomyces",
      "fr": "/vin/[slug]/levures-saccharomyces"
    },
    "vino/[slug]/lieviti-non-saccharomyces": {
      "it": "/vino/[slug]/lieviti-non-saccharomyces",
      "en": "/wine/[slug]/non-saccharomyces-yeasts",
      "es": "/vino/[slug]/levaduras-no-saccharomyces",
      "fr": "/vin/[slug]/levures-non-saccharomyces"
    },
    "birra/index": {
      "it": "/birra",
      "en": "/beer",
      "es": "/cerveza",
      "fr": "/biere"
    },
    "birra/[slug]/index": {
      "it": "/birra/[slug]",
      "en": "/beer/[slug]",
      "es": "/cerveza/[slug]",
      "fr": "/biere/[slug]"
    },
    "birra/[slug]/lieviti-liquidi": {
      "it": "/birra/lieviti-liquidi",
      "en": "/beer/liquid-yeasts",
      "es": "/cerveza/levaduras-liquidas",
      "fr": "/biere/levures-liquides"
    },
    "birra/[slug]/alta-fermentazione": {
      "it": "/birra/[slug]/alta-fermentazione",
      "en": "/beer/[slug]/high-fermentation",
      "es": "/cerveza/[slug]/alta-fermentacion",
      "fr": "/biere/[slug]/levures-de-haute-fermentation"
    },
    "birra/[slug]/bassa-fermentazione": {
      "it": "/birra/[slug]/bassa-fermentazione",
      "en": "/beer/[slug]/low-fermentation",
      "es": "/cerveza/[slug]/baja-fermentacion",
      "fr": "/biere/[slug]/levures-de-basse-fermentation"
    },
    "agricoltura/index": {
      "it": "/agricoltura",
      "en": "/agriculture",
      "es": "/agricultura",
      "fr": "/agriculture"
    },
    "panificati/index": {
      "it": "/panificati",
      "en": "/bakery-products",
      "es": "/panaderia",
      "fr": "/produits-boulangers"
    },
    "nutraceutica/index": {
      "it": "/nutraceutica",
      "en": "/nutraceuticals",
      "es": "/nutraceutica",
      "fr": "/nutraceutique"
    },
    "come-fare-per/[slug]/index": {
      "it": "/come-fare-per/[slug]",
      "en": "/how-to/[slug]",
      "es": "/como-hacer-para/[slug]",
      "fr": "/comment-faire-pour/[slug]"
    },
    "modalita-d-uso/[slug]/index": {
      "it": "/modalita-duso/[slug]",
      "en": "/use-mode/[slug]",
      "es": "/modo-de-uso/[slug]",
      "fr": "/mode-demploi/[slug]"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "it",
    "site": "it",
    "language": "it-IT",
    "name": "Italiano",
    "files": []
  },
  {
    "code": "en",
    "site": "en",
    "language": "en-US",
    "name": "English",
    "files": []
  },
  {
    "code": "es",
    "site": "es",
    "language": "es-ES",
    "name": "Español",
    "files": []
  },
  {
    "code": "fr",
    "site": "fr",
    "language": "fr-FR",
    "name": "Français",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
